var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.user?.tiimio_admin)?_c('div',[_c('v-btn',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Luo raportti'),expression:"'Luo raportti'"}],attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.push('/reports/create')}}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }